import React, { useContext, useEffect } from "react"
import styled from "styled-components"
import SearchBar from "../SearchBar"
import { Close } from "@styled-icons/evaicons-solid"
import StickyHeader from "../../../../context/stickyheaderContext"
import { ArrowRight } from "@styled-icons/bootstrap"
import { Link } from "react-router-dom"
import { kebabCase } from "../../../../utils/kebabCase"

const MenuItemsContainerMobile = styled.div`
	z-index: 10;
	top: -23px;
	width: calc(100% - 30px);
	box-sizing: border-box;
	height: 48px;
	border: 1px solid rgb(236, 236, 236);
	border-radius: 35px;
	background-color: rgb(255, 255, 255);
	box-shadow: rgba(0, 0, 0, 0.12) 4px 4px 12px 0px;
	position: absolute;
	display: flex;
	-webkit-box-align: center;
	align-items: center;
`
const MenuItemsMobile = styled.div`
	display: flex;
	width: 100%;
`

const OpenDropdownMobile = styled.button`
	width: 50%;
	background: none;
	border: none;
	padding: 0;
	font: inherit;
	cursor: pointer;
	outline: inherit;
	color: #747474;
	font-family: Mallory;
	font-size: 14px;
	font-weight: 500;
	letter-spacing: 0;
	line-height: 17px;
	display: flex;
	justify-content: center;
	align-items: center;
	flex: 1;
`

const CloseDropdownMobile = styled.button`
	width: 100%;
	background: none;
	border: none;
	padding: 0;
	font: inherit;
	cursor: pointer;
	outline: inherit;
	color: #747474;
	font-family: Mallory;
	font-size: 14px;
	font-weight: 500;
	letter-spacing: 0;
	line-height: 17px;
`

const DropdownMenuMobile = styled.div`
	position: absolute;
	z-index: 1;
	box-sizing: border-box;
	height: auto;
	width: 95%;
	border: 1px solid #ececec;
	border-radius: 35px 35px 15px 15px;
	background-color: #ffffff;
	box-shadow: 4px 4px 12px 0 rgb(0 0 0 / 12%);
	padding-top: 40px;
	top: -14px;
`

const DropdownMenuItemsMobile = styled(Link)`
	border-bottom: 1px solid #ececec;
	/* border-radius: 35px 35px 15px 15px; */
	background-color: transparent;
	color: black;
	display: block;
	padding: 12px;
	text-decoration: none;
	display: flex;
	justify-content: center;
	&:last-child {
		border-bottom: none;
	}
`

const CloseIcon = styled(Close)`
	font-family: Mallory;
	color: #747474;
	margin-bottom: 3px;
`

const CloseIconFull = styled(Close)`
	position: absolute;
	left: 21px;
	top: 48%;
	transform: translateY(-50%);
	transition: 0.3s;
	fill: #747474;
	z-index: 100;
	margin-bottom: 3px;
`

const CategoryIcon = styled.img`
	padding-right: 11.5px;
`

const CategoryTitle = styled.span`
	color: #747474;
	font-family: Mallory;
	font-size: 14px;
	font-weight: 500;
	letter-spacing: 0;
	line-height: 17px;
`

const HeaderBarText = styled.div`
	color: #000000;
	font-family: Mallory;
	font-size: 14px;
	font-weight: 500;
	letter-spacing: 0;
	line-height: 17px;
	text-align: center;
	padding-left: 14px;
	margin-right: auto;
`

const CloseIconContainer = styled.span`
	padding-left: 3.5px;
`

const SearchProceedButtonMobile = styled.button`
	height: 42px;
	width: 44px;
	background-color: #798775;
	border: none;
	color: white;
	border-radius: 50%;
	margin-right: 2px;
`

const menuItemContainerSticky = {
	width: "100%",
	borderRadius: "0px",
}

const menuItemsSticky = {
	justifyContent: "flex-end",
}

const categoryIconSticky = {
	paddingLeft: "11.5px",
	paddingRight: "0px",
}

const dropdownMenuMobileSticky = {
	borderRadius: "0px",
	top: "-1px",
}

const openDropdownMenu = {
	width: "145px",
}

const titleCase = (input) => {
	input = input
		.toLowerCase()
		.split(" ")
		.map(function (word) {
			return word.replace(word[0], word[0].toUpperCase())
		})

	return input.join(" ")
}

export const MainContainerMobile = (props) => {
	const stickyContext = useContext(StickyHeader)
	const { isStickyHeader } = stickyContext

	return (
		<div className="filter-main-container-mobile">
			<MenuItemsContainerMobile
				style={isStickyHeader ? menuItemContainerSticky : null}
			>
				{props.showMobileDropdown ? (
					<>
						<CloseDropdownMobile
							onClick={() => {
								props.toggleMobileMenu()
							}}
						>
							<span>CLOSE</span>
							<CloseIconContainer>
								<CloseIcon size="18" />
							</CloseIconContainer>
						</CloseDropdownMobile>
					</>
				) : (
					<>
						{props.barType ? (
							<>
								<MenuItemsMobile style={isStickyHeader ? menuItemsSticky : null}>
									{isStickyHeader ? (
										<HeaderBarText>Milligram Notes</HeaderBarText>
									) : (
										<></>
									)}
									<OpenDropdownMobile
										style={isStickyHeader ? openDropdownMenu : null}
										onClick={() => {
											props.toggleMobileMenu()
										}}
									>
										{!isStickyHeader ? (
											<>
												<CategoryIcon
													src="https://milligram.cdn.prismic.io/milligram/392fb57e-9e09-4866-ab14-267c98824bc3_categories_icon.svg"
													alt="category_icon"
												/>
												<CategoryTitle>CATEGORIES</CategoryTitle>
											</>
										) : (
											<>
												<CategoryTitle>CATEGORIES</CategoryTitle>
												<CategoryIcon
													style={isStickyHeader ? categoryIconSticky : null}
													src="https://milligram.cdn.prismic.io/milligram/392fb57e-9e09-4866-ab14-267c98824bc3_categories_icon.svg"
													alt="category_icon"
												/>
											</>
										)}
									</OpenDropdownMobile>
									{!isStickyHeader ? (
										<SearchBar
											handleClick={() => props.setBarType(false)}
											type={props.barType}
											handleInputChange={props.handleInputChange}
											searchValue={props.searchValue}
										></SearchBar>
									) : (
										<></>
									)}
								</MenuItemsMobile>
							</>
						) : (
							<>
								<CloseIconContainer>
									<CloseIconFull
										size="18"
										onClick={() => {
											props.setBarType(true)
											props.clearFilter()
											props.resetSearch()
										}}
									/>
								</CloseIconContainer>
								<SearchBar
									type={props.barType}
									handleInputChange={props.handleInputChange}
									searchValue={props.searchValue}
								></SearchBar>
								<SearchProceedButtonMobile onClick={() => props.setBarType(true)}>
									<ArrowRight size="16" />
								</SearchProceedButtonMobile>
							</>
						)}
					</>
				)}
			</MenuItemsContainerMobile>
			<>
				{props.showMobileDropdown ? (
					<DropdownMenuMobile
						style={isStickyHeader ? dropdownMenuMobileSticky : null}
					>
						<DropdownMenuItemsMobile
							to={`/blogs/all`}
							className={props.activeCategory == "all" ? "active-category" : ""}
							key={`all`}
							onClick={(e) => {
								props.clearFilter()
								props.handleClick(e, "all")
								props.toggleMobileMenu()
							}}
						>
							All
						</DropdownMenuItemsMobile>
						{props.items.map((category, i) => {
							return (
								<>
									<DropdownMenuItemsMobile
										to={`/blogs/all/tagged/${kebabCase(category.data.title[0].text)}`}
										className={
											props.activeCategory !== "all" &&
											props.activeCategory === category.slugs[0]
												? "active-category"
												: ""
										}
										key={`${category.data.title[0]}-${i}}`}
										onClick={(e) => {
											props.handleClick(e, category.data.title[0].text)
										}}
									>
										{titleCase(category.data.title[0].text)}
									</DropdownMenuItemsMobile>
								</>
							)
						})}
					</DropdownMenuMobile>
				) : (
					<></>
				)}
			</>
		</div>
	)
}
